import React from 'react';
import Header2 from '../component/common/title';
import Contentsubpagemenu from '../component/layout/content-sub-page-menu';
import pic26 from '../assets/pic26.png'
import './content-mangement-navigations.css'
import Input from '../component/common/input';
import { useState } from 'react';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import SaveCTA from '../component/common/savecta';
import Popup from '../component/common/popup';


const Contentmanagementnavs = () => {



         const [Navs, setNavs]= useState([]);

        useEffect(() => {
        const getNavs = async()=>{
            const res = await supabase.from('nav-header_content').select('*').order('id', { ascending: true });;
        setNavs(res.data);
        }
        getNavs();
        }, []);



        const handleChange = (id, field, value) => {

                setNavs((prev) =>
                    prev.map((item) =>
                        item.id === id
                            ? { ...item, [field]: value }
                            : item ) );};


    const saveChanges = async () => {

        for (const item of Navs) {

            await supabase
                .from('nav-header_content')
                .update({
                    name: item.name,
                    url: item.url
                })
                .eq('id', item.id);

        }

         setShowPopup(true); 

    };


const [popup, setpopup] = useState('');
const [showPopup, setShowPopup] = useState(false);
const closePopup = () => {
  setShowPopup(false);
};


useEffect(() => {
const getpopup = async()=>{
    const res = await supabase.from('Popup_content').select('*').order('id', { ascending: true });;

setpopup(res.data);
}
getpopup();
}, []);



const [searchTerm, setSearchTerm] = useState('');

const filteredNavs = Navs.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.url.toLowerCase().includes(searchTerm.toLowerCase())
);

    return ( 


 <section className='information-container'>


        <article className='header-cont-event'>
                           <Header2
                            title="Content Management"  
                            para="Manage website content and pages dynamically"
                            />
                            

                          <section className='container-table2-eventp'>
                            

                            <Contentsubpagemenu />


                            <section className='container-table-eventp'>
                                <fieldset className="input-wrapper">
                                    <input 
                                    className='input-search'
                                     placeholder="Search ..."
                                         value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
                                    />

                                     <img src={pic26} className="search-icon" alt="search" />
                                 </fieldset>

                                <section className='container-navigation-content'>

                                    <article className='container-part1-navigation-content'>
                                        <article className='header-container-content-change-p'>
                                            <h2 className='header-content-change-page'>Navigation Content</h2>
                                            <p className='para-content-change-page'>Manage website navigation menu items and links</p>
                                        </article>

                                        <section className='containerr-inputs-content-changeee-page'>
  
                                                       {filteredNavs.map((item, index) => (
        
                                                        <article 
                                                            className='row-navigation-inputs'
                                                            key={item.id}
                                                        >

                                                            <Input
                                                                  title={`Menu Label ${index + 1}`}
                                                                value={item.name}
                                                               onChange={(e) =>
                                                                    handleChange(item.id, 'name', e.target.value)
                                                                }

                                                            />

                                                            <Input
                                                               title={`URL ${index + 1}`}
                                                                value={item.url}
                                                           onChange={(e) =>
                                                                    handleChange(item.id, 'url', e.target.value)
                                                                }
                                                                />

                                                        </article>

                                                    ))}

                                        </section>

                                                    <button className='container-save-cta'>

                                                    <SaveCTA title='Save Changes'  onClick={saveChanges} />
                                                    </button>



                                    </article>





                                </section>





                    {showPopup && (
                            <Popup
                            to="/content-management-navigations" 
                                onClose={closePopup}
                            img={popup?.[2]?.image} 
                                alt={popup?.[2]?.icon_alt} 
                            header={popup?.[2]?.title}
                            para={popup?.[2]?.paragraph} 
                            title={popup?.[2]?.cta_text_primary} 
                            />
                    )}






                            </section>
                            
                        </section>     
                            

                                
                                  
        </article>

</section>


     );
}
 
export default Contentmanagementnavs;